import utils from "../../../utils/utils.js";

export default {
    async fetchOperationRecentActions(context) {        
        const response = await utils.utility.fetch("api/Editor/GetUserTransactions", "GET", null, null);

        const responseData = await response.data.feeds;      
         
        context.commit("setRecentAction", responseData);
    }
}